import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styles from './SimpleClub.module.css';
import routes from 'routes';
import SplitFastLogo from 'assets/images/splitfast-logo-header.png';

const SimpleClub = ({ club }) => {
  return (
    <Link to={routes.admin.dashboard} className={styles.clubInfo}>
      <img
        src={club?.image || SplitFastLogo}
        alt={club?.clubName || 'SplitFast'}
        className={styles.clubLogo}
      />
      <span className={styles.clubName}>{club?.clubName}</span>
    </Link>
  );
};

SimpleClub.propTypes = {
  club: PropTypes.object,
};

export default SimpleClub;
